// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customLabel {
  opacity: 0.6;
}

ion-button {
  bottom: 0px;
  position: absolute;
  right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/common/sharedComponents/header-intervento/header-intervento.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;AACF","sourcesContent":[".customLabel {\r\n  opacity: 0.6;\r\n}\r\n\r\nion-button {\r\n  bottom: 0px;\r\n  position: absolute;\r\n  right: 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
